import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { HolidayBadge } from "@/components/holiday/HolidaySkin";
import { Menu, X } from "lucide-react";
import { useI18n } from "@/context/I18nContext";
import { useAuth } from "@/context/AuthContext";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";
import { BackButton } from "@/components/BackButton";
import { useLocation } from "react-router-dom";

const LINKS = [["how", "ld.nav_how"], ["examples", "ld.nav_examples"], ["fx", "ld.nav_fx"], ["platforms", "ld.nav_platforms"], ["free", "ld.nav_free"], ["faq", "ld.nav_faq"]];

export const LandingNav = () => {
  const { t } = useI18n();
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const [solid, setSolid] = useState(false);
  useEffect(() => {
    const f = () => setSolid(window.scrollY > 24);
    f(); window.addEventListener("scroll", f, { passive: true });
    return () => window.removeEventListener("scroll", f);
  }, []);
  return (
    <header className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${solid || open ? "bg-[#0b0e1a]/90 backdrop-blur-xl border-b border-white/[0.07]" : "bg-transparent"}`} data-testid="landing-nav">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center gap-3 sm:gap-6">
        {pathname !== "/" && <BackButton testid="landing-back-btn" className="shrink-0 [&>span]:hidden sm:[&>span]:inline" />}
        <Link to="/" data-testid="nav-logo" className="relative shrink-0"><img src="/logo-wide.png" alt="CLIP-EX" className="h-8 sm:h-9 w-auto drop-shadow-[0_0_14px_rgba(167,70,255,0.45)]" /><HolidayBadge className="-top-2 -right-3" /></Link>
        <nav className="hidden xl:flex items-center gap-1.5 whitespace-nowrap cx-metal-rail rounded-xl p-1">
          {LINKS.map(([id, k]) => <a key={id} href={`/#${id}`} data-testid={`nav-${id}`} className="cx-metal cx-nav-sticker rounded-lg px-3 py-1.5">{t(k)}</a>)}
          <NavLink to="/tarifs" data-testid="nav-tarifs-link" className={({ isActive }) => `cx-metal cx-nav-sticker rounded-lg px-3 py-1.5 !text-[#7ee8ff] ${isActive ? "cx-metal-active" : ""}`}>{t("tf.nav")}</NavLink>
          <NavLink to="/vitrine" data-testid="nav-vitrine" className={({ isActive }) => `cx-metal cx-nav-sticker rounded-lg px-3 py-1.5 !text-[#ffc94d] ${isActive ? "cx-metal-active" : ""}`}>{t("vt.nav")}</NavLink>
          <NavLink to="/defis" data-testid="nav-challenges-link" className={({ isActive }) => `cx-metal cx-nav-sticker rounded-lg px-3 py-1.5 !text-[#ff7a92] ${isActive ? "cx-metal-active" : ""}`}>{t("ch.nav")}</NavLink>
        </nav>
        <div className="ml-auto flex items-center gap-2 sm:gap-3">
          <div className="hidden sm:block w-40" data-testid="nav-lang-switcher"><LanguageSwitcher /></div>
          {user ? (
            <Link to="/dashboard" data-testid="nav-open-app-btn" className="cx-btn rounded-full px-5 py-2 text-sm font-semibold whitespace-nowrap">{t("ld.open_app")}</Link>
          ) : (<>
            <Link to="/login?mode=register" data-testid="nav-try-btn" className="hidden md:inline-flex cx-try-btn rounded-full px-4 py-2 text-sm font-semibold text-white whitespace-nowrap">{t("ld.try_nav")}</Link>
            <Link to="/login" data-testid="nav-login-btn" className="cx-btn rounded-full px-5 py-2 text-sm font-semibold whitespace-nowrap">{t("ld.login")}</Link>
          </>)}
          <button onClick={() => setOpen((o) => !o)} className="xl:hidden text-slate-300 p-1" data-testid="nav-menu-toggle" aria-label="menu">{open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}</button>
        </div>
      </div>
      {open && (
        <div className="xl:hidden px-5 pb-5 space-y-1" data-testid="nav-mobile-menu">
          {LINKS.map(([id, k]) => <a key={id} href={`/#${id}`} onClick={() => setOpen(false)} className="cx-metal cx-nav-sticker block rounded-lg px-4 py-2.5 my-1.5">{t(k)}</a>)}
          <Link to="/tarifs" onClick={() => setOpen(false)} className="cx-metal cx-nav-sticker block rounded-lg px-4 py-2.5 my-1.5 !text-[#7ee8ff]" data-testid="nav-mobile-tarifs">{t("tf.nav")}</Link>
          <Link to="/vitrine" onClick={() => setOpen(false)} className="cx-metal cx-nav-sticker block rounded-lg px-4 py-2.5 my-1.5 !text-[#ffc94d]" data-testid="nav-mobile-vitrine">{t("vt.nav")}</Link>
          <Link to="/defis" onClick={() => setOpen(false)} className="cx-metal cx-nav-sticker block rounded-lg px-4 py-2.5 my-1.5 !text-[#ff7a92]" data-testid="nav-mobile-challenges">{t("ch.nav")}</Link>
          <div className="pt-3 sm:hidden"><LanguageSwitcher /></div>
        </div>
      )}
    </header>
  );
};
